import { useMemo, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

function getTimeOfDayGreeting() {
  const hour = new Date().getHours()

  if (hour < 12) return { greeting: 'Good morning', icon: '☀️', color: 'from-amber-50' }
  if (hour < 17) return { greeting: 'Good afternoon', icon: '👋', color: 'from-sky-50' }
  return { greeting: 'Good evening', icon: '🌙', color: 'from-indigo-50' }
}

export function StatusHeader({
  userName,
  followingCount = 0,
  reservedCount = 0,
  hasUnreadNotifications = false,
  actionRequired = false
}) {
  const { greeting, icon, color } = useMemo(() => getTimeOfDayGreeting(), [])
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    setIsVisible(true)
  }, [])

  return (
    <div className={`sticky top-0 z-10 bg-gradient-to-b ${color} to-white border-b border-neutral-200 -mx-4 md:-mx-6 px-4 md:px-6 py-4 md:py-6 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}>
      <div className="max-w-4xl mx-auto">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1 min-w-0">
            <h1 className="text-2xl md:text-3xl font-light text-neutral-900 mb-1 flex items-center gap-2">
              <span className="text-2xl">{icon}</span>
              <span>
                {greeting}
                {userName && <span className="font-medium">, {userName}</span>}
              </span>
            </h1>

            <div className="h-px bg-neutral-200 my-3 md:my-4" />

            <div className="space-y-2">
              <div className="flex items-center gap-2 text-sm md:text-base text-neutral-700">
                <span className="text-primary-600">Following {followingCount} {followingCount === 1 ? 'project' : 'projects'}</span>
                {reservedCount > 0 && (
                  <>
                    <span className="text-neutral-400">•</span>
                    <span className="text-primary-600">{reservedCount} reserved</span>
                  </>
                )}
              </div>

              <div className="flex items-center gap-2">
                {actionRequired ? (
                  <div className="flex items-center gap-2 text-warning-700">
                    <span className="w-2 h-2 rounded-full bg-warning-500 animate-pulse" />
                    <span className="text-sm font-medium">Action required</span>
                  </div>
                ) : (
                  <div className="flex items-center gap-2 text-success-700">
                    <span className="text-success-600">✓</span>
                    <span className="text-sm">Everything up to date</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <Link
            to="/notifications"
            className="flex-shrink-0 relative p-2 rounded-lg hover:bg-neutral-100 transition-colors touch-target"
            aria-label="View notifications"
          >
            <svg
              className="w-6 h-6 text-neutral-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
              />
            </svg>
            {hasUnreadNotifications && (
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-primary-500 rounded-full border-2 border-white" />
            )}
          </Link>
        </div>
      </div>
    </div>
  )
}
